import { mapState, mapMutations } from 'vuex'

import {
  apiSearchMobilier,
  apiSearchPredictibles,
  apiGetForm
} from '@/services/API/menus'

import { apiGetSinister, apiPostSinisterId } from '@/services/API/sinister'
import debounce from '@/utils/debounce'
import { cloneDeep } from 'lodash'
import maForm from '@/components/form'
import maFormGeneral from '../formGeneral'
import maDamageCpi from '../damageTypeCpi'
import { WARRANTY_MODULE_NAME, WARRANTY_UPDATE_CREATED } from '@/store/types'

import {
  WATER_MOBILIER_DAMAGES,
  BIENS_IMMOBILIERS,
  PROPERTY_TYPE,
  ASSETS,
  SELECT,
  RADIO,
  IMG_RADIO
} from '@/constants'

const DAMAGE_TYPE_CPI = 'CPI'
const DAMAGE_TYPE_FEATURE = 'FEATURE'
const DAMAGE_TYPE_ADHOC = 'ADHOC'

export default {
  name: 'searchMobilier',
  components: {
    maForm,
    maFormGeneral,
    maDamageCpi
  },
  data: function() {
    return {
      listKey: 0,
      listNestedTitles: [],
      inputTxtValue: '',
      searchIsActive: false,
      searchNotFound: false,
      listPredictibles: [],
      isFormVisible: false,
      formDataGeneral: {},
      titleFormGeneral: '',
      levelsToHide: [],
      lastLevelVisitedName: null,
      levelsInfo: {},
      level1Name: null,
      level1Tree: [],
      level2Name: null,
      level2Tree: [],
      level3Name: null,
      level3Tree: [],
      formType: null,
      poductIdGroup: null
    }
  },
  computed: {
    ...mapState(WARRANTY_MODULE_NAME, {
      stateWarrantySinisterId: 'sinisterId',
      stateWarrantySecondaryId: 'secondaryId',
      stateWarrantyPropertyType: 'propertyType',
      stateWarrantyId: 'warrantyId',
      stateWarrantyCreated: 'created',
      stateWarrantyReport: 'report',
      stateWarrantyForms: 'forms'
    }),

    warrantyid: function() {
      return this.$route.meta.warrantyid || ''
    },

    warrantyCategory: function() {
      return this.$route.meta.warranty_subtype_id
    },

    isDamageTypeCpi() {
      return this.formType !== null && this.formType === DAMAGE_TYPE_CPI
    },

    comWarrantyCreated: {
      get() {
        return this.stateWarrantyCreated
      },
      set(v) {
        this.mutWarrantyUpdateCreated(v)
      }
    }
  },

  methods: {
    ...mapMutations(WARRANTY_MODULE_NAME, {
      mutWarrantyUpdateCreated: WARRANTY_UPDATE_CREATED
    }),

    async getForm(
      level1ItemKey = null,
      level2ItemKey = null,
      level3ItemKey = null
    ) {
      const warrantyId = this.$route.meta.id
      const formParams = this.getFormParams(
        level1ItemKey,
        level2ItemKey,
        level3ItemKey
      )
      const { form } = await apiGetForm(warrantyId, formParams)

      this.setLevelNames({ ...form })
      return { ...form }
    },

    setFormType(form) {
      this.formType = null
      this.poductIdGroup = null

      const filteredForm = this.removeHiddenInputs(form)
      const attributeForms = this.attributeForms(filteredForm)

      attributeForms.forEach(input => {
        return input.options?.forEach(option => {
          const keyUptecItem = option.key.toUpperCase()
          if (
            option.is_upptec_damage &&
            option.upptec_damage_type === DAMAGE_TYPE_CPI &&
            keyUptecItem === this.lastLevelVisitedName
          ) {
            this.formType = DAMAGE_TYPE_CPI
            this.poductIdGroup = option.upptec_product_group_id
          } else if (
            option.is_upptec_damage &&
            option.upptec_damage_type === DAMAGE_TYPE_FEATURE
          ) {
            this.formType = DAMAGE_TYPE_FEATURE
          } else if (!this.formType) {
            this.formType = DAMAGE_TYPE_ADHOC
          }
        })
      })
    },

    attributeForms(form) {
      return form.filter(input => input.name.includes('ATTRIBUTE_'))
    },

    setLevelNames(form) {
      let mobilierDamagesForm = this.getMobilierDamagesForm(form)
      let filteredForm = this.removeHiddenInputs(mobilierDamagesForm)

      const FALLBACK_NAME = ''
      if (this.level1Name == null) {
        this.level1Name = this.isValidLevel(filteredForm[0])
          ? filteredForm[0].name
          : FALLBACK_NAME
      }
      if (this.level2Name == null) {
        this.level2Name = this.isValidLevel(filteredForm[1])
          ? filteredForm[1].name
          : FALLBACK_NAME
      }
      if (this.level3Name == null) {
        this.level3Name = this.isValidLevel(filteredForm[2])
          ? filteredForm[2].name
          : FALLBACK_NAME
      }
    },

    removeHiddenInputs(form) {
      return form.inputs.filter(input => {
        return input.type !== 'hidden'
      })
    },

    isValidLevel(input) {
      return (
        input.type === SELECT ||
        input.type === RADIO ||
        input.type === IMG_RADIO
      )
    },

    getFormParams(
      level1ItemKey = null,
      level2ItemKey = null,
      level3ItemKey = null
    ) {
      let formParams = {}
      formParams[PROPERTY_TYPE] = this.stateWarrantyPropertyType
      formParams[ASSETS] = BIENS_IMMOBILIERS

      if (level1ItemKey) {
        formParams[this.level1Name] = level1ItemKey
      }
      if (level2ItemKey) {
        formParams[this.level2Name] = level2ItemKey
      }
      if (level3ItemKey) {
        formParams[this.level3Name] = level3ItemKey
      }
      return formParams
    },

    getMobilierDamagesForm(form) {
      return form.regions.find(region => region.name === WATER_MOBILIER_DAMAGES)
    },

    async setLevel1() {
      let form = await this.getForm()
      let mobilierDamagesForm = this.getMobilierDamagesForm(form)

      this.level1Tree = this.fetchLevel1Tree(mobilierDamagesForm)
      this.level2Tree = []
      this.level3Tree = []

      this.resetForm()

      return mobilierDamagesForm
    },

    setUpperLevels(level1ItemKey, level2ItemKey, form) {
      this.level1Tree = this.fetchLevel1Tree(form).filter(
        level1Item => level1Item.key === level1ItemKey
      )
      this.level2Tree = this.fetchLevel2Tree(form).filter(
        level2Item => level2Item.key === level2ItemKey
      )
    },

    resetForm() {
      this.isFormVisible = false
      this.titleFormGeneral = ''
      this.inputTxtValue = ''
      this.lastLevelVisited = null
    },

    fetchLevel1Tree(form) {
      let level1List = form.inputs.filter(input => {
        return input.name === this.level1Name
      })[0].options
      return cloneDeep(level1List)
    },

    fetchLevel2Tree(form) {
      let level2List = form.inputs.filter(input => {
        return input.name === this.level2Name
      })[0].options
      return cloneDeep(level2List)
    },

    fetchlevel3Tree(form) {
      let level3List = form.inputs.filter(input => {
        return input.name === this.level3Name
      })[0].options
      return cloneDeep(level3List)
    },

    async handleLevel1Click(level1ItemKey) {
      this.lastLevelVisitedName = level1ItemKey

      let form = await this.getForm(level1ItemKey)
      let mobilierDamagesForm = this.getMobilierDamagesForm(form)

      this.level1Tree = this.fetchLevel1Tree(mobilierDamagesForm).filter(
        level1Item => level1Item.key === level1ItemKey
      )
      this.level2Tree = this.fetchLevel2Tree(mobilierDamagesForm)
      this.level3Tree = []

      this.resetForm()
    },

    async handleLevel2Click(level1ItemKey, level2ItemKey, level2ItemLiteral) {
      this.lastLevelVisitedName = level2ItemKey

      let form = await this.getForm(level1ItemKey, level2ItemKey)
      let mobilierDamagesForm = this.getMobilierDamagesForm(form)

      this.setUpperLevels(level1ItemKey, level2ItemKey, mobilierDamagesForm)

      if (
        mobilierDamagesForm.inputs.some(input => input.name === this.level3Name)
      ) {
        this.level3Tree = cloneDeep(
          mobilierDamagesForm.inputs.find(
            input => input.name === this.level3Name
          ).options
        )
        this.resetForm()
      } else {
        this.level3Tree = []
        this.handleCreateSinister(mobilierDamagesForm)

        this.titleFormGeneral = level2ItemLiteral
        this.levelsInfo = { ...this.getFormParams(level1ItemKey, level2ItemKey) }
        this.levelsToHide = [this.level1Name, this.level2Name]

        form.regions.forEach(region => {
          if (region.name === WATER_MOBILIER_DAMAGES) {
            region.inputs = region.inputs.filter(
              input => this.levelsToHide.indexOf(input.name) === -1
            )
          }
          return region
        })

        this.refreshForm(form)
      }
    },

    async handleLevel3Click(
      level1ItemKey,
      level2ItemKey,
      level3ItemKey,
      level3ItemLiteral
    ) {
      this.lastLevelVisitedName = level3ItemKey
      this.titleFormGeneral = level3ItemLiteral
      this.levelsInfo = { ...this.getFormParams(level1ItemKey, level2ItemKey, level3ItemKey) }
      this.levelsToHide = [this.level1Name, this.level2Name, this.level3Name]

      let form = await this.getForm(level1ItemKey, level2ItemKey, level3ItemKey)
      let mobilierDamagesForm = this.getMobilierDamagesForm(form)

      this.handleCreateSinister(mobilierDamagesForm)

      this.setUpperLevels(level1ItemKey, level2ItemKey, mobilierDamagesForm)
      this.level3Tree = this.fetchlevel3Tree(mobilierDamagesForm)

      form.regions.forEach(region => {
        if (region.name === WATER_MOBILIER_DAMAGES) {
          region.inputs = region.inputs.filter(
            input => this.levelsToHide.indexOf(input.name) === -1
          )
        }
        return region
      })

      this.refreshForm(form)
    },

    refreshForm(form) {
      this.formDataGeneral = cloneDeep(form)
      this.inputTxtValue = ''
      this.isFormVisible = true
      this.listKey = this.listKey + 1
    },

    handleChangeInputTxt: debounce(function() {
      this.searchNotFound = false
      const searchedValue = this.inputTxtValue

      if (searchedValue.length < 2) {
        this.searchIsActive = false
        return
      }

      this.isFormVisible = false
      this.listNestedTitles = []
      this.searchIsActive = true
      const warrantyId = this.$route.meta.id

      if (searchedValue !== '') {
        apiSearchMobilier(warrantyId, searchedValue).then(result => {
          if (result.length > 0) {
            this.inputTxtValue === searchedValue && this.addNestedTitles(result)
          } else {
            this.searchNotFound = true
          }
        })
      }
    }, 250),

    addThirdLevelCategories(firstCategory, secondCategory) {
      secondCategory.children.forEach(thirdCategory => {
        this.listNestedTitles.forEach(title => {
          title.cat1.cat2.forEach(cat => {
            if (
              cat.literal === secondCategory.literal &&
              title.cat1.cat2.length &&
              title.cat1.literal === firstCategory.literal
            ) {
              if (!cat.cat3) cat['cat3'] = []
              if (secondCategory.children.length !== cat.cat3.length) {
                cat.cat3.push({
                  literal: thirdCategory.literal,
                  name1: firstCategory.component_name,
                  value1: firstCategory.component_value,
                  name2: secondCategory.component_name,
                  value2: secondCategory.component_value,
                  name3: thirdCategory.component_name,
                  value3: thirdCategory.component_value,
                  children: thirdCategory.children.length
                })
              }
            }
          })
        })
      })
    },
    addNestedTitles(list) {
      this.listNestedTitles = []
      list.forEach(firstCategory => {
        this.listNestedTitles.push({
          cat1: {
            literal: firstCategory.literal,
            name1: firstCategory.component_name,
            value1: firstCategory.component_value,
            children: firstCategory.children.length
          }
        })
        if (firstCategory.children.length > 0) {
          firstCategory.children.forEach(secondCategory => {
            this.listNestedTitles.forEach(title => {
              if (title.cat1.literal === firstCategory.literal) {
                if (!title.cat1.cat2) title.cat1['cat2'] = []
                if (firstCategory.children.length !== title.cat1.cat2.length) {
                  title.cat1.cat2.push({
                    literal: secondCategory.literal,
                    name1: firstCategory.component_name,
                    value1: firstCategory.component_value,
                    name2: secondCategory.component_name,
                    value2: secondCategory.component_value,
                    children: secondCategory.children.length
                  })
                }
              }
            })
            if (secondCategory.children.length > 0) {
              this.addThirdLevelCategories(firstCategory, secondCategory)
            }
          })
        }
      })
    },

    getPredictibles() {
      const warrantyId = this.$route.meta.id
      apiSearchPredictibles(warrantyId).then(res => {
        this.listPredictibles = res
      })
    },

    handleClickPredictibles(levels) {
      switch (levels.length) {
        case 1:
          return this.handleLevel1Click(levels[0].component_value)
        case 2:
          return this.handleLevel2Click(
            levels[0].component_value,
            levels[1].component_value
          )
        case 3:
          return this.handleLevel3Click(
            levels[0].component_value,
            levels[1].component_value,
            levels[2].component_value,
            levels[2].literal
          )
        default:
          throw new Error(
            `searchMobilier.handleClickPredictibles: level of predecitibles: ${levels.length} not implemented`
          )
      }
    },

    isSelectedElement(literal) {
      return literal === this.titleFormGeneral
    },

    async handleCreateSinister(form) {
      this.setFormType(form)

      if (
        this.stateWarrantyCreated == null &&
        this.stateWarrantySinisterId != null
      ) {
        try {
          await apiGetSinister(this.stateWarrantySinisterId)
          this.comWarrantyCreated = true
        } catch (_) {
          this.createSinister()
        }
      }
    },

    createSinister() {
      apiPostSinisterId(
        this.stateWarrantySinisterId,
        this.stateWarrantySecondaryId
      )
        .then(() => {
          this.comWarrantyCreated = true
        })
        .catch(() => {
          this.throwNotification(
            this.$t('notifications.error.title'),
            this.$t('notifications.error.body'),
            'KO'
          )
        })
    }
  },

  async mounted() {
    this.getPredictibles()
    await this.setLevel1()
  },

  beforeDestroy: function() {
    this.inputTxtValue = ''
    this.mutWarrantyUpdateTextSearchMobilier('')
  }
}
